import React, { useEffect, useState } from "react";
import { Card, Tag, Typography as typography_antd } from "antd";
import "./index.css";
import { Editor } from "react-draft-wysiwyg";
import { convertToHTML } from "draft-convert";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { toast } from "react-toastify";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import CompanyPolicyStyle from "./CompanyPolicyStyle";
import {
  EditorState,
  ContentState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import { Button, MenuItem, Select, Switch, Typography } from "@mui/material";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import env from "../../config/env";
import { fetchRoleData } from "../../redux/slice/getRoleData";
import { useDispatch, useSelector } from "react-redux";
import { logout, setToken, setUserData } from "../../redux/slice/authSlice";
import CryptoJS from "crypto-js";

const { Title, Text } = typography_antd;
const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

const CompanyPolicy = (props) => {
  const token = useSelector((state) => state.auth.token);
  const { state } = useLocation();
  let userId = props.userData.id;

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [companyPolicy, setCompanyPolicy] = useState();
  const [companyPolicyPublish, setCompanyPolicyPublish] = useState("");
  const [convertedContent, setConvertedContent] = useState(null);
  const [roleData, setRoleData] = useState();
  const [listValue, setListValue] = useState(state.liValue);
  const [status, setStatus] = useState("Draft");
  const [publishStatus, setPublishStatus] = useState();
  const [loading, setloading] = useState(false);
  const [selectVal, setSelectVal] = useState();
  const [apiCondition, setApiCondition] = useState("");
  const navigate = useNavigate();
  let dispatch = useDispatch();

  let tempstate = useSelector((state) => state);
  if (tempstate?.getRoleData?.data?.status === 555 || tempstate?.getRoleData?.data?.status === 501) {
    dispatch(setToken(null));
    dispatch(setUserData(null));
    toast.error("Session expire, Please LogIn!", {
      position: toast.POSITION.TOP_RIGHT,
      toastId: "1",
    });
    Navigate("/login")
  }
  const tempRoleData = tempstate?.getRoleData.data.data;

  useEffect(() => {
    setApiCondition(state.docId)
    dispatch(fetchRoleData(token));
  }, [token]);

  useEffect(() => {
    getRoleData();
  }, [tempRoleData]);

  useEffect(() => {
    if (companyPolicy) {
      // const contentDataStateBookDescription = ContentState.createFromBlockArray(
      //   convertFromHTML(companyPolicy)
      // );
      // console.log(contentDataStateBookDescription,"");
      // const editorDataStateBookDescription = EditorState.createWithContent(
      //   contentDataStateBookDescription
      // );
      // setEditorState(editorDataStateBookDescription);
      const blocksFromHtml = htmlToDraft(companyPolicy);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(
        contentBlocks,
        entityMap
      );
      const editorState = EditorState.createWithContent(contentState);
      setEditorState(editorState);
    }
    if (companyPolicy === "") {
      setEditorState(EditorState.createEmpty());
    }
  }, [companyPolicy]);

  useEffect(() => {
    let html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setConvertedContent(html);
  }, [editorState]);

  const getRoleData = async () => {
    const optionList = [];

    tempRoleData &&
      tempRoleData.forEach((element) => {
        optionList.push({
          label: `${element.value}`,
          value: `${element.id}`,
        });
      });
    setRoleData(optionList);
    let optionListValue = 0;
    if (optionList.length > 0) {
      optionListValue = optionList[0].value;
    }
    todata(listValue);
    setloading(true);
  };

  const todata = async (val) => {

    try {

      // Encrypt data
      const encryptedVal = CryptoJS.AES.encrypt(val.toString(), SECRET_KEY).toString();;
      const encodedVal = encodeURIComponent(encryptedVal); // ✅ very important

      //Encrypt api endpoint
      const getPolicy = CryptoJS.SHA256("/getPolicy" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

      const response = await fetch(
        `${env.backend_api_endpoint}/${getPolicy}?roleId=${encodedVal}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.status === 555 || errorData.status === 501) {
          dispatch(setToken(null));
          dispatch(setUserData(null));
          toast.error("Session expire, Please LogIn!", {
            position: toast.POSITION.TOP_RIGHT,
            toastId: "1",
          });
          Navigate("/login")
        }
        if (errorData.status === 400) {
          setCompanyPolicy("");
          setCompanyPolicyPublish("");
          setApiCondition("")
          setPublishStatus("");
        }
        if (errorData.status === 404) {
          setCompanyPolicy("");
          setCompanyPolicyPublish("");
          setApiCondition("")
          setPublishStatus("");
        }
      }

      if (response.ok) {
        const successData = await response.json();
        if (successData.status === 200 && successData.data) {

          // Decrypt backend response
          const bytes = CryptoJS.AES.decrypt(successData.data, SECRET_KEY);
          const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

          let arr = "";
          let policy_publish = "";
          let policy_status = "";

          decryptedData.forEach((element) => {
            arr = element.policy_details;
            policy_publish = element.policy_details_publish;
            setApiCondition(element.id)
            policy_status = element.status;
          });
          setCompanyPolicy(arr);
          setCompanyPolicyPublish(policy_publish);
          setPublishStatus(policy_status);
        }
      }
    } catch (error) {
      console.error("Error get Policy in:", error.message);
    }
  };

  const handleClick = async () => {
    let objadd = {
      created_by: props.userData.id,
      created_date: new Date(),
      policy_details_publish:
        status == "Publish" ? convertedContent : companyPolicyPublish,
      policy_details: convertedContent,
      policy_version: "1.0",
      role: parseInt(listValue),
      status: status,
    };
    // parseInt(listValue)

    if (!apiCondition) {
      try {

        const data = {
          policyDetails: convertedContent,
          roleId: parseInt(listValue),
          status: status
        }

        // Encrypt data
        const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

        //Encrypt api endpoint
        const addPolicy = CryptoJS.SHA256("/addPolicy" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        const response = await fetch(`${env.backend_api_endpoint}/${addPolicy}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedData: encryptedBody }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          if (errorData.status === 404) {
          }
          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login")
          }
        }

        if (response.ok) {
          const successData = await response.json();
          if (successData.status === 200) {
            toast.success("Changes saved successfully!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            navigate("/companypolicy");
          }
        }
      } catch (error) {
        console.error("Error Add Policy in:", error.message);
      }
    }
    else {
      try {

        const data = {
          policyId: apiCondition,
          policyDetails: convertedContent,
          roleId: parseInt(listValue),
          status: status
        }

        // Encrypt data
        const encryptedBody = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();;

        //Encrypt api endpoint
        const updatePolicy = CryptoJS.SHA256("/updatePolicy" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

        const response = await fetch(`${env.backend_api_endpoint}/${updatePolicy}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: token,
          },
          body: JSON.stringify({ encryptedData: encryptedBody }),
        }
        );
        if (!response.ok) {
          const errorData = await response.json();

          if (errorData.status === 555 || errorData.status === 501) {
            dispatch(setToken(null));
            dispatch(setUserData(null));
            toast.error("Session expire, Please LogIn!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            Navigate("/login")
          }
        }
        if (response.ok) {
          const successData = await response.json();
          if (successData.status === 200) {
            toast.success("Changes saved successfully!", {
              position: toast.POSITION.TOP_RIGHT,
              toastId: "1",
            });
            navigate("/companypolicy");
          }
        }
      } catch (error) {
        console.error("Error Update Policy in:", error.message);
      }
    }
  };

  const handleChange = (val) => {
    todata(val);
    setListValue(val);
    setSelectVal(val);
  };

  const onSwitchChange = (value) => {
    if (value === true) {
      setStatus("Publish");
    } else {
      setStatus("Draft");
    }
  };
  const handlechange = () => {
    document.getElementById("savechanges").style.opacity = 1;
  };
  return (
    <CompanyPolicyStyle>
      <div className="site-card-border-less-wrapper">
        <Card
          bodyStyle={{ height: "calc(100vh - 100px)" }}
          className="card"
          bordered={false}
          style={{
            margin: 10,
          }}
        >
          {loading ? (
            <>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Title
                  level={2}
                  style={{
                    color: "#244DA0",
                    fontFamily: "ImportedMilliardSemibold",
                    fontWeight: 500,
                  }}
                >
                  Company Policy
                </Title>

                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  defaultValue={listValue}
                  value={selectVal}
                  // label="Role"
                  onChange={(e) => handleChange(e.target.value)}
                  className="Select_role"
                >
                  {roleData &&
                    roleData.map((role) => (
                      <MenuItem key={role.value} value={role.value}>
                        {role.label}
                      </MenuItem>
                    ))}
                </Select>

                {companyPolicy != "" && (
                  <Tag color="orange"
                    style={{
                      marginLeft: "25px",
                      height: "fit-content",
                      alignSelf: "center",
                    }}>
                    {publishStatus}
                  </Tag>
                )}

              </div>
              {/* <div> */}
              {/* <Editor
                  editorState={editorState}
                  onEditorStateChange={setEditorState}
                  wrapperClassName="wrapper-class"
                  editorClassName="editor-class"
                  toolbarClassName="toolbar-class"
                  wrapperStyle={{ height: "50vh", padding: "5px" }}
                  toolbar={{
                    options: ["inline", "blockType", "list", "link"],
                    inline: { inDropdown: false },
                    list: { inDropdown: true },
                    textAlign: { inDropdown: false },
                    history: { inDropdown: true },
                  }}
                  onChange={handlechange}
                /> */}
              <Editor
                editorState={editorState}
                onEditorStateChange={setEditorState}
                wrapperClassName="wrapper-class"
                editorClassName="editor-class"
                wrapperStyle={{ height: "calc(100vh - 350px)", padding: "5px" }}
                onChange={handlechange}
              />

              {/* <Button
                style={{ opacity: 0.5 }}
                id="savechanges"
                size="large"
                type="primary"
                htmlType="submit"
                onClick={handleClick}
              >
                Save Changes
              </Button> */}
              <div className="policy_footer_btn" style={{ display: "flex", }}>
                <div className="SwitchPolicy">
                  Publish Company Policy : &nbsp;
                  {/* <Switch onChange={onSwitchChange} /> */}
                  <Switch
                    onChange={(e) => {
                      onSwitchChange(e.target.checked);
                    }}
                  />
                </div>
                <Button
                  variant="contained"
                  size="medium"
                  onClick={handleClick}
                  id="savechanges"
                  className="update_policy_btn"
                  style={{ opacity: 0.5 }}
                >
                  Save Changes
                </Button>
              </div>
            </>
          ) : (
            <span class="loader"></span>
          )}
        </Card>
      </div>
    </CompanyPolicyStyle >
  );
};

export default CompanyPolicy;
